export var FILE_TYPE_IMAGE_PNG = 'image/png';
export var FILE_TYPE_IMAGE_JPEG = 'image/jpeg';
export var FILE_TYPE_IMAGE_GIF = 'image/gif';
export var FILE_TYPE_IMAGE = 'image';
export var FILE_TYPE_PDF = 'pdf';
export var MIME_TYPE_PDF = 'application/pdf';
export var MAX_FILE_UPLOADS = 10;
export var MAX_FILE_SIZE_BYTES = 8000000;